/**
 * True when running as an installed standalone PWA (added to home screen /
 * installed app).
 */
export function isStandaloneApp() {
    if (window.electron) return false;
    const mqStandAlone = '(display-mode: standalone)';
    return ((navigator as any).standalone || window.matchMedia(mqStandAlone).matches);
}
